<template>
    <div class="d-flex justify-content-center align-items-sm-center pt-5 pt-sm-0" style="min-height: 95vh">
        <div class="col-12 d-flex justify-content-center" style="max-width: 440px">
            <div class="pb-sm-2">
                <img
                    v-if="customLogoUrl === null"
                    src="/static/general/img/affinity-blue.svg"
                    alt="Affinity Learning logo"
                    height="18"
                />
                <div
                    v-else
                    class="logo-sm d-flex align-items-center rounded-circle custom-logo-circle logo"
                >
                    <img :src="customLogoUrl" />
                </div>
                <p class="text-secondary" style="margin-top: 20px;">Some additional information is required before viewing "{{ title }}"</p>
                <base-form ref="setupForm" class="mt-2" v-model="setupData" :fields="setupFields"></base-form>
                <p v-for="error in errors" :key="error" class="text-danger">{{ error }}</p>
                <div class="d-flex justify-content-end">
                    <button @click="submit()" :disabled="loading" class="btn btn-primary btn-sm">
                        <span v-show="loading" class="align-middle mr-2">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span class="sr-only">Loading...</span>
                        </span>
                        <span>Start</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BaseForm from "@/components/BaseForm"

export default {
    name: "ShareLinkSetup",
    components: {
        BaseForm,
    },
    props: {
        link: {
            type: Object,
            required: true,
        },
        title: {
            type: String,
            required: false,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        errors: {
            type: Array,
            required: false,
            default() {
                return []
            },
        },
    },
    data() {
        return {
            shareLink: this.link,
            setupData: {
                email: "",
                student_number: "",
                passcode: null,
            },
        }
    },
    watch: {
        link: function (newValue) {
            this.shareLink = newValue
        },
    },
    computed: {
        setupFields() {
            let vm = this
            let fields = [
                {
                    name: "Passcode",
                    subtext: "Enter the 5-digit passcode provided by your instructor.",
                    placeholder: "Passcode",
                    key: "passcode",
                    maxlength: 5,
                    required() {
                        return vm.shareLink.require_passcode
                    },
                    hidden() {
                        return !vm.shareLink.require_passcode
                    },
                },
                {
                    name: "Email",
                    key: "email",
                    subtext: "Enter an email associated with your institution, or one they may recognize",
                    placeholder: "someone@example.com",
                    required() {
                        return vm.shareLink.identification_method == "email"
                    },
                    hidden() {
                        return vm.shareLink.identification_method != "email"
                    },
                },
                {
                    name: "Student or Participant Number",
                    key: "student_number",
                    subtext: "Enter your student number or participant number.",
                    placeholder: "123456",
                    required() {
                        return vm.shareLink.identification_method == "student_number"
                    },
                    hidden() {
                        return vm.shareLink.identification_method != "student_number"
                    },
                },
            ]
            return fields
        },
        customLogoUrl() {
            return this.$store.getters.customLogoUrl
        },
    },
    methods: {
        submit() {
            if (!this.$refs.setupForm.validate()) {
                return
            }
            this.$emit("submit", this.setupData)
        },
    },
}
</script>

<style lang="scss" scoped>
.logo {
    width: 62px !important;
    height: 62px !important;
}
</style>